<div *ngIf="bookingSlot" class="from-time">
  <span class="hours">{{ getHourString(bookingSlot.fromTime) }}</span><span class="time-divider">:</span><span class="minutes">{{ getMinutesString(bookingSlot.fromTime)
    }} </span><span class="time-oclock">{{ "o'clock" | translate }}</span>
</div>
